/**************************************************
 * Nombre:       Formulario_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {
    AccountCircleOutlined,
    BadgeOutlined,
    LockOutline,
    MailOutline,
    PhoneAndroidOutlined
} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import 'react-medium-image-zoom/dist/styles.css'

const Formulario_Deposito = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={2} nombre={'Id'} dato={'id'} {...props}
                                  requerido={'El Nombres es requerido'} editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}
                                  requerido={'El Nombres es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}
                                  requerido={'El Apellidos es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'} dato={'cc'} {...props}
                                  requerido={'El Numero de identificacion es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Num Celular'} dato={'celular'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'El Correo es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={LockOutline} nombre={'Contraseña'} dato={'pass'}
                                  {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Deposito